define('plugins/musicfavourite/ui/localisation',['require'],function(exports) {

    /**
     * Retrieve a localised string based on a translation key and category. Falls back
     * to "en-gb" translations when keys/categories are missing.
     *
     * Finds translations from scanning a map in following structure:
     * {
     *     "{{lang}}": {
     *         "{{category}}": {
     *             "{{key}}": "{{translatedText}}"
     *         }
     *     }
     * }
     *
     * @private
     *
     * @param  {object} o        Object containing text translations map.
     * @param  {string} key      Key for translation text.
     * @param  {string} category Category for translation test (probably variant). Defaults to "standard".
     * @param  {string} lang     Language for lookup, defaults to "en-gb".
     * @return {string}          Translated text for key.
     */
    exports.getLocalisedString = function(o, key, category, lang, defaultText) {
        var translatedKeys;

        if (!lang || !o[lang]) {
            lang = 'en-gb'; // default
        }

        translatedKeys = o[lang];

        category = category || 'standard';
        key = key || '';
        defaultText = (defaultText !== undefined) ? defaultText : key;

        if (translatedKeys && translatedKeys[category] && translatedKeys[category][key]) {
            return translatedKeys[category][key];
        }

        return lang !== 'en-gb' && exports.getLocalisedString(o, key, category, 'en-gb') || defaultText;
    };

    return exports;
});

